//////////////////////////////////////////////////////////////
// Thumbnails Screen

import m from "mithril";

import {defineWidget, Empty, CardieWidget, NoticeWidget} from "@nebularstreams/libmui"

import MAINSTATE, {STATE_THUMBNAILS as STATE} from "../State";

import {TitleBarWidget} from "./misc/TitleBarWidget";
import {StreamCard} from "./misc/StreamCard";

//////////////////////////////////////////////////////////////

const {service: SERVICE} = STATE;

//////////////////////////////////////////////////////////////

const

	// widget: Playlist
	ImageWrapperWidget = defineWidget(
		({attrs, state}) => ([
				m(".tvscreen.flexcol.fixed", state.image
					? [
						m("div.image", {
							class: "image169",
							onclick: () => state.refresh && state.refresh()
						}, [
							m("img", {
								src: state.image
							}),
						])

					] : [
						m(Empty, {
							class: "darkie",
							icon: "image",
							message: attrs.message || "No thumbnail found"
						})
					]),
				...state.image
					? [
						m(NoticeWidget, {
							icon: "link",
							text: state.image.split("?")[0],
							class: "link"
						})
					] : []

			]
		),
		({attrs, state}) => {

			const
				img = new Image();

			img.onload = () => {
				state.image = img.src;
				m.redraw();
			}

			state.refresh = () => {
				STATE.cacheKey = Date.now();
				img.src = [STATE.webroot, attrs.image].join("/") + "?_" + STATE.cacheKey;
			}


			if (attrs.autoRefresh) {
				state.refresher = setInterval(state.refresh, attrs.autoRefresh);
			}

			state.refresh();

		},
		undefined,
		({state}) => clearInterval(state.refresher)
	),

	// widget: Main Screen
	ThumbnailsScreen = defineWidget(
		() => [
			m(TitleBarWidget, {
				title: "Thumbnails",
				rootTitle: "Studio",
				rootTitleClick: () => m.route.set(`/${STATE.orga}`)
			}),
			m(".flexcol.h-100.ohidden.grows.scrolly.outercontent",
				m(".flexcol.grows.noshrink.innercontent", [

					m(StreamCard, {state: STATE, service: SERVICE, orga: STATE.orga, class: "firstlevel"}),

					// body
					m(".flexrow.ohidden.maincontainer", STATE.streamname
						? [
							m(".flexcol.grows.ohidden.part-left", [
								m(CardieWidget, {
										class: "",
										title: "Last Static Thumbnail",
										element: "div",
										cols: true,
										nofold: true,
									},
									m(ImageWrapperWidget, {
										key: STATE.streamname,
										image: [STATE.orga, SERVICE, STATE.streamname + ".jpg"].join("/"),
										autoRefresh: 35000
									}))
							]),
							m(".flexcol.grows.ohidden.part-right", [
								m(CardieWidget, {
										class: "",
										title: "Last Animated Thumbnail",
										element: "div",
										cols: true,
										nofold: true,
									},
									[
										m(ImageWrapperWidget, {
											key: STATE.streamname,
											image: [STATE.orga, SERVICE, STATE.streamname + ".gif"].join("/"),
											message: "No MovieClip found",
											autoRefresh: 65000
										}),

									])
							]),
						]
						: []
					)
				])
			)
		],
		({attrs}) => {

			STATE.orga = attrs.orga || MAINSTATE.organization;

			if (attrs.key) {
				STATE.streamname = attrs.key;
			} else if (STATE.streamname) {
				m.route.set(`/${STATE.orga}/${SERVICE}/${STATE.streamname}`);
			}

			document.title = "thumbnails - nanoStream Studio"

		}
	);

export default ThumbnailsScreen;
